import equal from 'deep-equal';
import { debounce } from 'lodash';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Button from '../../components/button';
import Translator from '../../services/translate-factory';
import * as Constants from '../../store/constants/all';
import { routes } from '../../store/constants/routes';
import type * as Types from '../../store/types';

type ConstrLoginProps = {
  dispatch?: any;
  user?: Types.IAuthUser;
};

declare const appSettings: Types.IAppSettings;

export const IConstrLogin = ({ dispatch, user }: ConstrLoginProps) => {
  const T = new Translator();
  const [, forceRender] = React.useReducer((x) => x + 1, 0);

  const handleLanguageChange = React.useCallback(
    debounce(() => {
      forceRender();
    }, 1000),
    [],
  );
  useEffect(() => {
    T.removeListener(Constants.gen.CORE_CHANGE_LANGUAGE, handleLanguageChange);
    T.addListener(Constants.gen.CORE_CHANGE_LANGUAGE, handleLanguageChange);
    window.scrollTo(0, 0);
    return () => {
      T.removeListener(Constants.gen.CORE_CHANGE_LANGUAGE, handleLanguageChange);
    };
  }, []);

  // @origin "https://dev-constructor.dev"
  // @basepath " ", "/schedule"
  const { origin } = new URL(appSettings.API_URL);
  // Use routes.LOGIN_CALLBACK for the redirect
  const redirect = encodeURIComponent(`${origin}${appSettings.BASE_PATH}${routes.LOGIN_CALLBACK}`);

  return (
    <div className="login-button-container">
      <Button
        className="primary"
        onClick={() => {
          const url = new URL(`/oidc/login?redirectUrl=${redirect}`, origin);
          console.log('redirecting to:', { urlstring: url.toString() });
          window.location.href = url.toString();
        }}
      >
        {T.t('gen_sign_in_with_constructor')}
      </Button>
    </div>
  );
};

const areStatesEqual = (next: Types.IPersistedState, prev: Types.IPersistedState) => {
  return equal(prev, next);
};

const mapStateToProps = (
  store: Types.IPersistedState,
  ownProps: ConstrLoginProps,
): ConstrLoginProps => {
  if (!store?.state) {
    return ownProps;
  }

  const newProps: any = Object.assign({}, ownProps, {
    user: store.state.user,
  });

  return newProps;
};

const dispatchProps = (dispatch: any) => ({ dispatch });

const ConstrLogin = connect(mapStateToProps, dispatchProps, null, { areStatesEqual })(IConstrLogin);

export default ConstrLogin;
